export function formattedPrice(price: any, selectedCurrency: any, currency_symbol: string) {
  // Input validation: guard against null/undefined/empty price
  if (!price || price === null || price === undefined) {
    return "";
  }

  const priceString = String(price).trim();
  if (!priceString) {
    return "";
  }

  if (selectedCurrency == "AUD") {
    // AUD branch: Add validation and use optional chaining
    if (typeof priceString !== 'string') {
      return priceString || "";
    }
    return priceString?.replace(/\.0+(?!\d)/, "")?.replace("AU", "") || "";
  } else {
    // Split validation: handle cases where split doesn't work as expected
    const parts = priceString.split(/\s+/);
    
    // Fallback if length of parts is only equal to 1 (it doesn't split)
    if (parts.length === 1) {
      // Return the original price string as fallback
      return priceString;
    }

    // Optional chaining to catch nested parts
    const countryCode = parts[0];
    const amount = parts[1];
    
    // Validate that both parts exist before processing
    if (!countryCode || !amount) {
      return priceString; // Return original if parts are missing
    }

    // Use optional chaining for nested operations
    const cleanedAmount = amount?.replace(/\.0+(?!\d)/, "") || amount;
    return `${currency_symbol}${cleanedAmount} ${countryCode}`;
  }
}